import { isDesktop } from './helpers';
const $ = window.jQuery;

//
// Handle scrolled state of header.
//

//
// Sensitivity is the bottom point of ther hero.
//
let sensitivity = 5;
getSensitivity();
$( window ).resize( getSensitivity );
function getSensitivity() {
	if ( $( '.entry-content' ).children().eq(0).hasClass( 'background-image' ) ) {
		sensitivity = ( $( '.entry-content' ).children().eq(0).innerHeight() / 2 ) - ( $( '.site-header' ).height() / 2 ) - 80;
		return;
	};
	return;
}

let scrolled = false;

const $header = $( '.site-header' );

// document.addEventListener( 'scroll', handleScrolledHeader );
// window.requestAnimationFrame( handleScrolledHeader );
// function handleScrolledHeader() {
// 	if ( window.scrollY > sensitivity && ! scrolled ) {
// 		window.requestAnimationFrame( () => {
// 			document.querySelector( '.site-header' ).classList.add( 'scrolled' );
// 		} );
// 		scrolled = true;
// 		return;
// 	}

// 	if ( window.scrollY < sensitivity && scrolled ) {
// 		window.requestAnimationFrame( () => {
// 			document.querySelector( '.site-header' ).classList.remove( 'scrolled' );
// 		} );
// 		scrolled = false;
// 		return;
// 	}
// }

// On mobile, only show fixed header if scrolling up
// let transitioning = false;
// let eventListener = false;
// let isFixed = false;

// $( window ).resize( handleResize );
// handleResize()
// function handleResize() {

// 	if ( isDesktop() && false !== eventListener ) {
// 		document.removeEventListener( 'scroll', handleScroll );
// 		eventListener = false;
// 		return;
// 	}

// 	if ( ! isDesktop() && false === eventListener ) {
// 		eventListener = true;
// 		document.addEventListener( 'scroll', handleScroll );
// 	}
// }

// let lastPositionY = window.scrollY || 0;
// function handleScroll() {

// 	if ( $( '.mobile-panel' ).hasClass( 'open' ) ) {
// 		lastPositionY = window.scrollY;
// 		return;
// 	}

// 	if ( window.scrollY < 1 && isFixed ) {
// 		$header.removeClass( 'mobile-fixed' );
		
// 	// Don't do this unless we are a bit into the page
// 	} else if ( ! transitioning && window.scrollY > 500 && window.scrollY < lastPositionY - 10 && ! isFixed ) {
// 		transitioning = true;
// 		isFixed       = true;

// 		$header.css( 'opacity', '0' );
// 		window.requestAnimationFrame( function() {
// 			$header.css( 'transition', 'opacity 600ms ease-in-out' );
// 			$header.css( 'opacity', '1' );
// 			$header.addClass( 'mobile-fixed' );
// 		} );

// 		window.setTimeout( function() {
// 			$header.css( 'transition', '' );
// 			transitioning = false;
// 		}, 600 );
// 	} else if ( ! transitioning && window.scrollY > lastPositionY + 10 && isFixed ) {
// 		// A little of leeway when scrolling down
// 		transitioning = true;
// 		isFixed       = false;

// 		$header.css( 'transition', 'opacity 400ms ease-in-out' );
// 		window.requestAnimationFrame( function() {
// 			$header.css( 'opacity', '0' );
// 		} );

// 		window.setTimeout( function() {
// 			$header.css( 'transition', '' );
// 			$header.css( 'opacity', '1' );
// 			$header.removeClass( 'mobile-fixed' );
// 			transitioning = false;
// 		}, 400 );
// 	}

// 	lastPositionY = window.scrollY;
// }
